import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress, Divider, IconButton } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { HHNTheme, useTranslation } from "hhn-commons";
import * as React from "react";
import { IconSearch, SearchContainer, SearchWrapper } from "./SearchBox.style";

export interface SearchBoxProps {
  placeholderLabel?: string;
  children?: React.ReactNode;
  searchText: string;
  searchTestId?: string;
  onSearchTextChange: (searchText: string) => void;
  onSearchClear: () => void;
  isLoading?: boolean;
  tabValue?: number;
  autoFocus?: boolean;
}

export const SearchBox = ({
  placeholderLabel,
  children,
  searchText,
  searchTestId,
  onSearchTextChange,
  onSearchClear,
  isLoading,
  tabValue,
  autoFocus = false,
}: SearchBoxProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const label = placeholderLabel ?? tNs("searchPlaceholder");
  return (
    <SearchWrapper>
      <SearchContainer variant="outlined">
        <IconButton type="button" sx={{ padding: "4 0 0 0" }}>
          <IconSearch fontSize={"small"} />
        </IconButton>
        <InputBase
          sx={{ flex: 1 }}
          placeholder={label}
          inputProps={{
            "aria-label": label,
            "data-testid": searchTestId ?? "search-input",
          }}
          onChange={e => onSearchTextChange(e.target.value)}
          value={searchText}
          autoFocus={autoFocus}
        />
        {searchText.length > 0 && !isLoading && (
          <IconButton
            type="button"
            sx={{ p: "6px" }}
            aria-label="search"
            data-testid="clear-search"
            onClick={onSearchClear}
          >
            <CloseIcon style={{ color: HHNTheme.common.black }} fontSize="small" />
          </IconButton>
        )}
        {isLoading && (
          <CircularProgress sx={{ p: "6px" }} size={28} color="primary" />
        )}
        {children && (tabValue === 0 || !tabValue) && (
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        )}
        {children && children}
      </SearchContainer>
    </SearchWrapper>
  );
};
